import { initialStyles, Modal } from '@/components/modal/Modal'

interface Props {
  isOpen: boolean
  onClose: () => void
}
const modalStyle = {
  ...initialStyles,
  content: {
    ...initialStyles.content,
    width: '600px',
  },
}

export const NotAllowedAutoPlayModal: React.FC<Props> = ({
  isOpen,
  onClose,
}) => {
  return (
    <Modal open={isOpen} onRequestClose={onClose} style={modalStyle}>
      <div className="relative p-[10px] font-medium text-white bg-[#4a85c7] border-l-[10px] border-[#3069b0] border-solid">
        <h5 className="m-0 text-base text-white">音声自動再生</h5>
      </div>
      <div className="relative p-[15px]">
        <div className="text-center">
          サイトの設定で「音声の自動再生」を許可してからご利用ください。
          <br />
          設定の詳細は
          <a
            href="https://flierinc.freshdesk.com/support/solutions/articles/69000775673-%E3%82%A6%E3%82%A7%E3%83%96%E3%83%96%E3%83%A9%E3%82%A6%E3%82%B6%E3%81%A7%E8%A6%81%E7%B4%84%E3%81%AE%E8%87%AA%E5%8B%95%E9%80%A3%E7%B6%9A%E5%86%8D%E7%94%9F%E3%81%8C%E3%81%A7%E3%81%8D%E3%81%AA%E3%81%84%E3%81%AE%E3%81%A7%E3%81%99%E3%81%8C%E3%80%81%E3%81%A9%E3%81%86%E3%81%99%E3%82%8C%E3%81%B0%E8%89%AF%E3%81%84%E3%81%A7%E3%81%99%E3%81%8B-"
            target="_blank"
            rel="noreferrer"
          >
            こちら
          </a>
          をご覧ください。
        </div>
      </div>
      <div className="p-[15px] text-center border-none">
        <button
          className="inline-block relative py-[6px] px-3 pb-1 mb-0 text-sm font-normal leading-6 text-center text-white align-middle whitespace-nowrap bg-[#337ab7] rounded border border-[#2e6da4] border-solid cursor-pointer"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </Modal>
  )
}
